import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useRole } from "../lib/roleContext";

/**
 * Route guard for admin-only pages (/syncs/new, /test-upload, /settings).
 * RoleProvider has already resolved the role by the time routes render (it
 * gates on loading), so a plain redirect is safe — read-only users land
 * back on the dashboard. The API enforces the same boundary server-side.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { isAdmin } = useRole();
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
